import type { ReactNode } from 'react';
import { DiscoveryLayout } from '@/domains/paydirt/layout/DiscoveryLayout';

export type TenantDiscoveryLayoutProps = {
  children: ReactNode;
  right?: ReactNode;
  hideSidebar?: boolean;
};

/** Deploy-time tenant discovery chrome. Tour builds skip paydirt sidebar (TourChrome owns layout). */
export function TenantDiscoveryLayout({ children, right, hideSidebar }: TenantDiscoveryLayoutProps) {
  if (process.env.NEXT_PUBLIC_TOUR_BUILD === 'true') {
    return <>{children}</>;
  }
  return (
    <DiscoveryLayout right={right} hideSidebar={hideSidebar}>
      {children}
    </DiscoveryLayout>
  );
}
